import * as R from 'remeda';
import { ActionType } from 'typesafe-actions';

import * as productivityActions from './actions';
import * as productivityConstants from './constants';
import productivityReducer from './reducer';
import * as productivitySagas from './sagas';
import * as productivitySelectors from './selectors';

export type ProductivityState = {
  selectedWeek: Time.Week;
  selectedDay: Time.Day;
  pivotById: Record<string, boolean>;
};

export type ProductivityAction = ActionType<typeof productivityActions>;

// Only user-intent actions watched by the saga watcher — narrows the
// SagaAction union so dispatch typing stays precise.
const _productivitySagaActions = R.pick(productivityActions, [
  'startToggleHours',
]);

export type ProductivitySagaAction = ActionType<
  typeof _productivitySagaActions
>;

export {
  productivityActions,
  productivityConstants,
  productivityReducer,
  productivitySagas,
  productivitySelectors,
};
